import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { CheckCircle2, Lock } from 'lucide-react';
export function Offer() {
  return <section id="offer" className="py-14 md:py-16 bg-brand-cream relative" data-id="element-166">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl" data-id="element-167">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="bg-white rounded-3xl shadow-2xl overflow-hidden border border-brand-gold/20" data-id="element-168">
          <div className="bg-brand-navy p-8 md:p-12 text-center relative overflow-hidden" data-id="element-169">
            <div className="absolute top-0 left-0 w-full h-full bg-[url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4IiBoZWlnaHQ9IjgiPgo8cmVjdCB3aWR0aD0iOCIgaGVpZ2h0PSI4IiBmaWxsPSIjMEIxRTNGIj48L3JlY3Q+CjxwYXRoIGQ9Ik0wIDBMOCA4Wk04IDBMMCA4WiIgc3Ryb2tlPSIjMUQzNTY0IiBzdHJva2Utd2lkdGg9IjEiPjwvcGF0aD4KPC9zdmc+')] opacity-20" data-id="element-170"></div>
            <h2 className="relative z-10 text-3xl md:text-4xl font-serif font-bold text-white mb-4" data-id="element-171">
              Recupera tu figura y tu bienestar hoy mismo.
            </h2>
            <p className="relative z-10 text-brand-cream/90 text-lg max-w-2xl mx-auto" data-id="element-172">
              Olvida las dietas fallidas y toma el control de tu salud con
              herramientas que funcionan en la realidad chilena.
            </p>
          </div>

          <div className="p-8 md:p-12" data-id="element-173">
            <div className="flex flex-col md:flex-row gap-12 items-center justify-between" data-id="element-174">
              <div className="flex-1 w-full" data-id="element-175">
                <h3 className="text-xl font-bold text-brand-navy mb-6" data-id="element-176">
                  Tu acceso incluye:
                </h3>
                <ul className="space-y-4" data-id="element-177">
                  {['eBook: Plan Antinflamatorio 15-Min', 'Protocolo Reset 72h (Express)', "Lista de Compras 'Zero Estrés'", 'Recetario Express (Menos de 15 min)'].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-178">
                      <CheckCircle2 className="w-5 h-5 text-brand-green shrink-0" data-id="element-179" />
                      <span className="text-gray-700 font-medium" data-id="element-180">{item}</span>
                    </li>)}
                </ul>
              </div>

              <div className="flex-1 w-full flex flex-col items-center text-center bg-brand-cream/50 p-8 rounded-2xl border border-brand-gold/30" data-id="element-181">
                <p className="text-sm font-bold text-brand-gold uppercase tracking-wider mb-2" data-id="element-182">
                  Solo por hoy
                </p>
                <div className="flex items-center justify-center gap-2 mb-1" data-id="element-183">
                  <span className="text-lg text-gray-400 line-through font-medium" data-id="element-184">
                    $47.990
                  </span>
                  <span className="text-xs font-bold text-white bg-brand-green px-2 py-0.5 rounded-full uppercase tracking-wide" data-id="element-185">
                    -87%
                  </span>
                </div>
                <div className="flex items-end justify-center gap-2 mb-2" data-id="element-186">
                  <span className="text-5xl font-bold text-brand-navy" data-id="element-187">
                    $6.390
                  </span>
                  <span className="text-xl font-bold text-brand-navy mb-1" data-id="element-188">
                    CLP
                  </span>
                </div>
                <p className="text-gray-500 text-sm mb-8" data-id="element-189">
                  Pago único, acceso inmediato
                </p>

                <Button checkout fullWidth className="text-lg py-5 shadow-xl shadow-brand-gold/20" data-id="element-190">
                  ¡SÍ, QUIERO DESINFLAMAR MI ABDOMEN AHORA!
                </Button>

                <div className="flex items-center justify-center gap-2 mt-4 text-xs text-gray-500" data-id="element-191">
                  <Lock className="w-4 h-4" data-id="element-192" />
                  <span data-id="element-193">Compra segura y descarga digital instantánea.</span>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}